import classNames from 'classnames';
import { showAlert } from '../../../../general-ui/alert/alert-service';

export function handleCopyUrl({
	isDarkMode,
	message = "Copied to clipboard"
}: {
	isDarkMode?: boolean;
	message?: string;
}) {
	const eventLink = window.location.href;
	navigator.clipboard.writeText(eventLink);

	showAlert({
		message,
		description: `\`\`\`${eventLink}\`\`\``,
		duration: 3000,
		type: "POSITIVE",
		descriptionStyle: { whiteSpace: "pre-wrap", wordBreak: "break-all" },
		className: classNames('copy-url-alert', { 'light-mode': isDarkMode === false })
	});
}

// Re-export component exports from the .tsx file so that imports resolving to this
// .ts module (which takes priority over .tsx in TypeScript's resolution) still work.
export { default } from './modal-social-buttons.tsx';
